import React from "react";
import {inject} from "mt-react-decorators";

@inject(['manager'])
export default class AveragesTable extends React.Component {

    get manager() {
        return this.props.manager;
    }

    get years() {
        return [
            this.manager.year,
        ];
    }

    get sections() {
        return [
            'Organisational',
            'Democratic',
            'Political',
            'Financial',
        ]
    }

    renderTableHeaders() {
        return (
            <div className={'mtt-sustainability-tool__averages-table-row mtt-sustainability-tool__averages-table-row--header-row'}>
                <div className={'mtt-sustainability-tool__averages-table-header'}></div>
                {
                    this.sections.map((section) => {
                        return (
                            <div className={'mtt-sustainability-tool__averages-table-header'}>
                                {section}
                            </div>
                        );
                    })
                }
            </div>
        )

    }

    renderTable() {
        return (
            this.years.map(year => {
                return (
                    <div className={'mtt-sustainability-tool__averages-table-row'}>
                        <div className={'mtt-sustainability-tool__averages-table-data'}>{year}</div>
                        {
                            this.sections.map((section) => {
                                return (
                                    <div className={'mtt-sustainability-tool__averages-table-data'} data-section={section}>
                                        {this.manager.getAverageValue(section, year) || 1}
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            })
        );
    }

    render() {
        return (
            <div className={'mtt-sustainability-tool__averages-table mtt-sustainability-tool__wrap'}>
                <div className={'mtt-sustainability-tool__averages-table-title mtt-sustainability-tool__wrap-title'}>Results</div>
                <div className={'mtt-sustainability-tool__averages-table-inner'}>
                    {this.renderTableHeaders()}
                    {this.renderTable()}
                </div>
            </div>
        );
    }
}